import { render } from "./ReassignAccountManagerNode.vue?vue&type=template&id=b91bd6d0"
import script from "./ReassignAccountManagerNode.vue?vue&type=script&lang=js"
export * from "./ReassignAccountManagerNode.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__